import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import alert from './alert/reducer';
import authentication from './authentication/reducer';
import billing from './billing/reducer';
import contact from './contact/reducer';
import recording from './recording/reducer';
import linkcode from './linkcode/reducer';
import user from './user/reducer';

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    alert,
    authentication,
    billing,
    contact,
    recording,
    linkcode,
    user,
  });

export default rootReducer;
